export default __webpack_public_path__ + "/assets/docx_big.png";